import { environment } from 'src/environments/environments';

/**
 * ===================================================
 *                 # GLOBAL CONFIG FILE #
 * ===================================================
 */
export const config = {
  /**
   * Base API Url:
   * [.../]
   */
  apiBaseUrl: environment.apiBaseUrl, // UNCOMMENT FOR Deployment DEV

  /* Not Secured FODE URI  */

  // openBaseUrl: 'https://dev-fode.force-n.sn/backfode',
  openBaseUrl: environment.openBaseUrl,

  /* Redirect Uri For Keycloak */

  // redirectURI: 'https://dev-fode.force-n.sn/fode/#/',
  // redirectURI: 'https://test-fode.force-n.sn/fode/#/',
  redirectURI: environment.redirectURI,
  // redirectURI: 'http://localhost:4200/#/',
};
